import axios from 'axios'

export default {
    oeamtcHeaderHTML() {
        return axios.get('/_external/hf-assets/v1/header?style=small')
    },
    oeamtcHeaderCSS() {
        return axios.get('/_external/hf-assets/v1/css')
    },
    oeamtcHeaderJS() {
        return axios.get('/_external/hf-assets/v1/js')
    },
    oeamtcHeaderTracking() {
        return axios.get('/_external/hf-assets/v1/tracking')
    },
    appConfig() {
        return axios.get('/routenplaner/config')
    }
}